import React, { useEffect, useState } from "react";
import StackedColumnChart from "../../CHARTS/StackedColumnChart";

const GraphPTDetention = ({ data, setLegendsData }) => {
  const [chartData, setChartData] = useState(null);
  useEffect(() => {
    if (data) {
      let array = data[0]?.children;
      let trainNumbers = new Set();
      let detCodeCountsByTrain = {};

      // Iterate through the data structure
      array?.forEach((section) => {
        section?.children.forEach((detCode) => {
          const currentDetCode = detCode?.DET_CODE;
          detCode?.children.forEach((subCode) => {
            // const currentDetCode = subCode?.SUB_CODE;

            subCode?.data.forEach((trainNo) => {
              const currentTrainNo = trainNo.TRAIN_NO;
              // Add train number to unique set
              trainNumbers.add(currentTrainNo);

              // Initialize nested structure for counts
              if (!detCodeCountsByTrain[currentTrainNo]) {
                detCodeCountsByTrain[currentTrainNo] = {};
              }
              if (!detCodeCountsByTrain[currentTrainNo][currentDetCode]) {
                detCodeCountsByTrain[currentTrainNo][currentDetCode] = 0;
              }
              // Increment count for SUB_CODE under DET_CODE and TRAIN_NO
              detCodeCountsByTrain[currentTrainNo][currentDetCode] =
                trainNo.TRAIN_LOST_COUNT +
                detCodeCountsByTrain[currentTrainNo][currentDetCode];
            });
          });
        });
      });

      // Convert unique train numbers to array
      const categories = Array.from(trainNumbers);

      // Get unique DET_CODE values
      const uniqueDetCodes = [
        ...new Set(
          Object.values(detCodeCountsByTrain).flatMap((detCodes) =>
            Object.keys(detCodes)
          )
        ),
      ];

      // Create series: one object per DET_CODE with counts across TRAIN_NO
      const series = uniqueDetCodes.map((detCode) => ({
        name: detCode,
        data: categories.map(
          (trainNo) => detCodeCountsByTrain[trainNo]?.[detCode] || 0
        ),
      }));

      // Final output
      const output = { categories, series };
      setChartData(output);
    }
  }, [data]);
  return (
    <div>
      {chartData && (
        <StackedColumnChart
          data={chartData}
          from={"trainDeTCode"}
          setLegendsData={setLegendsData}
        />
      )}
    </div>
  );
};

export default GraphPTDetention;
